<div class="page traveler quick-charts">

  <div class="row justify-center quick-charts" style="padding:0 4%;">

    @if (ready) {
      <mat-form-field class="bordered-select form-ctrl-margin-right fixed-height">
        <mat-label>Chart Type</mat-label>
        <ng-container>
          <mat-select [(ngModel)]="chart_type" (selectionChange)="getConfig()" [compareWith]="compare"
                      class="form-mat-select">
            @for (type of chart_types; track type.name) {
              <mat-option [value]="type">
                {{type.name}}
              </mat-option>
            }
          </mat-select>
        </ng-container>
      </mat-form-field>
    }

    <select-many-series [value]="selected_series"
                        (selectionChange)="selected_series = $event;getConfig();"
                        class="form-ctrl-margin-right"
    >
    </select-many-series>

    @if (ready) {
      <div (cdkDropListDropped)="drop($event)" cdkDropList class="drop-list">
        @if (selected_series) {
          @for (option of selected_series; track option.id; let i = $index) {
            <div cdkDrag class="drop-box">
              <div style="display: flex; align-items: center;">
                <series-edit-button (seriesUpdated)="updateSeries($event, option)"
                                    [panelClass]="'quick-charts'" [series_id]="option.id"
                                    [group]="tabGroups.OPERATIONS">
                </series-edit-button>
                {{option.attributes|nameOrDescription}}
              </div>
              <i class="fa fa-times" (click)="removeSeries(option)"
                 style="cursor: pointer;font-size: 1.33em;margin: 0 10px;color:#666666;"></i>
            </div>
          }
        }
      </div>
    } @if (ready) {
    <div>
      @if (selected_series && selected_series.length > 0) {
        <wire-button class="fullwidth button-margin" [btnContent]="'Queue Aggregation'"
                     [btnStyle]="'btn-default'"
                     [disabled]="!canQueueAggregations()"
                     (buttonClicked)="queueAggregations()">
        </wire-button>
      }
    </div>
  }

  </div>
  @if (showAggregationWarning) {
    <div class="aggregation-warning" role="alert">
      <i class="fa fa-exclamation-triangle"
         aria-hidden="true"></i>&nbsp;{{aggregationWarning}} {{seriesNotAllowed.join(", ")}}
    </div>
  }
  <div class="column quick-charts">
    @if (!['Multi Line', 'Multi Area', 'Multi Bar', 'Pie'].includes(chart_type.name)) {
      @for (series of selected_series; track series.id; let j = $index) {
        @if (tile_configs[series.id]) {
          <div>
            <h2>{{series.attributes|nameOrDescription}}</h2>
            <page-tile
                [dtp]="dateInst.dtp"
                [tile]="tile_configs[series.id]"
                [id]="j"
                class="page-tile no-format off-dashboard">
            </page-tile>
          </div>
        }
      }
    } @if (['Multi Line', 'Multi Area', 'Multi Bar', 'Pie'].includes(chart_type.name)) {
    @for (config of [configs]; track config) {
      <div><!--to force refresh-->
        <h2>{{selected_series_names}}</h2>
        <page-tile
            [dtp]="dateInst.dtp"
            [tile]="tile_configs[chart_type.name]"
            class="page-tile no-format off-dashboard">
        </page-tile>
      </div>
    }
  }

  </div>
</div>
